/** @jsx jsx */

import { forwardRef } from "react"
import { jsx, Select } from "theme-ui"
import { RiArrowDownSLine } from "react-icons/ri"
import PropTypes from "prop-types"

import theme from "../gatsby-plugin-theme-ui"

export const SelectField = forwardRef(
  (
    { name, options, defaultValue, value, onChange, onBlur, variant, sx },
    ref
  ) => (
    <Select
      id={name}
      name={name}
      variant={variant || "selectWhite"}
      arrow={
        <RiArrowDownSLine
          size={32}
          sx={{
            ml: -28,
            alignSelf: "center",
            pointerEvents: "none",
            color: theme.forms[variant]?.color || "text",
          }}
        />
      }
      {...(defaultValue ? { defaultValue } : {})}
      {...(value ? { value } : {})}
      onChange={onChange}
      onBlur={onBlur}
      sx={sx}
      ref={ref}
      // This is required to prevent a weird FF bug on refresh where the
      // selected value is not reset to the default one, but the previous
      // value seems to be "remembered"
      // https://stackoverflow.com/questions/3858359/how-do-i-reset-to-default-drop-down-list-option-on-refreshf5-in-firefox
      autoComplete="off"
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  )
)
SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  variant: PropTypes.string,
  sx: PropTypes.object,
}
